module.exports = __webpack_public_path__ + "09d59f11df120b9c6ce32412710335f9.svg";